// @flow

import {tableElements, withoutDataTableShadow} from '../constants';

export const generateShadow = (tableId: string) => {
    const rightTable = document.getElementById(`${tableId}-right`);
    const headers = rightTable && rightTable
        .getElementsByClassName(tableElements.frozenHeader.replace('.', ''));

    if (headers) {
        const headersLen = headers.length;
        [].forEach.call(headers, (el, ind) => {
            if (ind === (headersLen - 1)) {
                el.classList.remove(withoutDataTableShadow);
            } else {
                el.classList.add(withoutDataTableShadow);
            }
        });
    }
};
